<template>
  <div class="workspace-header">
    <div class="workspace-title-wrap">
      <el-button plain @click="emit('go-home')">返回</el-button>
      <div class="workspace-title-block">
        <div class="workspace-title">{{ currentPanelTitle }}</div>
        <div class="workspace-subtitle">{{ currentPanelDesc }}</div>
      </div>
    </div>
    <div class="workspace-header-right">
      <el-tag type="info" effect="plain">{{ serverModeLabel }}</el-tag>
      <el-tag :type="serverTagType">{{ serverName }}</el-tag>
    </div>
  </div>
</template>

<script setup>
defineProps({
  currentPanelTitle: { type: String, default: '' },
  currentPanelDesc: { type: String, default: '' },
  serverModeLabel: { type: String, default: '' },
  serverTagType: { type: String, default: 'info' },
  serverName: { type: String, default: '' },
});

const emit = defineEmits(['go-home']);
</script>

<style scoped>
.workspace-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.96), rgba(244, 248, 255, 0.94));
  border: 1px solid rgba(224, 231, 241, 0.98);
  border-radius: 14px;
  box-shadow: 0 8px 18px rgba(24, 40, 72, 0.06);
  backdrop-filter: blur(8px);
}

.workspace-title-wrap {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  min-width: 0;
}

.workspace-title-wrap :deep(.el-button) {
  min-width: 72px;
}

.workspace-title-block {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.workspace-title {
  font-size: 18px;
  font-weight: 800;
  color: #1f2d3d;
  line-height: 1.2;
}

.workspace-subtitle {
  font-size: 12px;
  color: #7c8798;
  line-height: 1.45;
  max-width: 720px;
}

.workspace-header-right {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  flex-wrap: wrap;
  flex-shrink: 0;
}

@media (max-width: 1180px) {
  .workspace-header {
    flex-direction: column;
    align-items: stretch;
  }
}

@media (max-width: 768px) {
  .workspace-title {
    font-size: 18px;
  }
}
</style>
